var map = {
	"./10valkas_edited.jpg": 79,
	"./15ditton.jpg": 80,
	"./15ditton_edited.jpg": 81,
	"./19valkas_edited.jpg": 82,
	"./4ditton_edited.jpg": 83,
	"./5valkas_edited.jpg": 84,
	"./6valkas_edited.jpg": 85,
	"./9ditton_edited.jpg": 86
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78;